import { getEditor } from './tiptap/editor_cache';
import { createRoot } from 'react-dom/client';
import { Initializer } from 'Shared/chakra-initialize';
import { TiptapEditor } from './tiptap/tiptap-lazy';
import { getFormParent } from './utils';

let renderedEditors = {};

const getSubmitHandler = pm => {
   const answerForm = getFormParent(pm);
   return () => {
      const formManager = answerForm.retrieve('FormManager:formManager');
      formManager.submit();
   };
};

const getDoc = text => {
   if (text) {
      const doc = JSON.parse(text);
      if (App.updateText) {
         doc.content.append(App.updateText.content);
      }
      return doc;
   }
   return '';
};

const getOrCreateTiptap = (editorid, pm) => {
   if (renderedEditors[editorid]) {
      return editorid;
   }
   renderedEditors[editorid] = true;

   const doc = getDoc(pm.dataset['text']);
   const EditorComponent = Initializer(TiptapEditor);
   const root = createRoot(pm);

   /* Disable editor if the user has less than 5000 reputation.
      The WYSIWYG editor is currently only being disabled for this case. */
   const editQuestion = document.getElementById('qaEditor');
   const disableEditor = editQuestion?.getAttribute('data-editable');

   root.render(
      <EditorComponent
         editorid={editorid}
         preset="answers"
         disabled={disableEditor}
         text={doc}
         submitHandler={getSubmitHandler(pm)}
      />
   );

   // We use editorids intead of handles for Tiptap
   return editorid;
};

export function getEditorid(pm, selector) {
   const answerForm = pm.closest(selector);
   return `${answerForm.id}-editor`;
}

export function getOrCreateHandle(pm, selector) {
   const editorId = getEditorid(pm, selector);
   return getOrCreateTiptap(editorId, pm);
}
